import requestUtil from "../../helpers/requestUtil";
import { setLoading } from "../common/Loader/slice";
import { convertToString } from "../JobOpportunity/recurrenceConvertToString/recurrenceConvertToString";
import {
  setJobId, updateViewJobDetails, setMasterData,
  updateShiftDetails, setFailureLogs, loadDataForEdit, updateJobInfo, setFormData, setModifyOccurrence, setLoadingFlagIncrement, setLoadingFlagDecrement, setJobDomainId, setOccurrenceViewVariableRate, setDepartmentList,
  setWorkBreakList
} from "./slice";
import * as Toasts from '../common/Toastify';
import moment from "moment";
import { getSingleShiftEndDate, updateShiftTime } from "../JobOpportunity/transformer";
import { shiftTypeObj } from "../../helpers/data";


export const patchDynamicForm = (original, updateVal) => {
  const newVal = JSON.parse(JSON.stringify(original));
  newVal.forEach(item => {
    const byFormID = updateVal.filter(item1 => item1.formId === item.formId)[0];
    item.controlsInfo.forEach(item3 => {
      if (byFormID) {
        const bySectionID = byFormID.jobProfileSections.filter(item4 => item4.formSectionId === item3.formsSectionID)[0];
        const arr = [];
        // console.log('-------------------------', item3)
        if (bySectionID.selectedValue?.length) {
          bySectionID.selectedValue.forEach(item5 => {
            const filterdata = item3.options.filter(val => val.id === item5)
            if (filterdata?.length) {
              arr.push(filterdata[0])
            }
          })
        }

        item3.selectedValueOptions = arr
      }
    })
  })
  return newVal
}

export const getViewJobDetails = ({ url, jobUniqueId, jobsClaimId, shiftDate }) => {
  return async (dispatch, getState) => {
    const state = getState();
    const { formdata } = state.viewJobDetails;
    const requestData = state.viewJobDetails.requestData;

    let str = ''
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());
    try {
      let newDynamicFormData = [];
      let dynamicFormData = []

      const params = {
        "jobUniqueId": jobUniqueId,
        "shiftDate": shiftDate ? shiftDate?.split('T')[0] : '',
        "jobsClaimId": jobsClaimId ? jobsClaimId : 0
      }
      const state = getState();
      const { masterData, requestData } = state.viewJobDetails;
      const viewJobDetails = await requestUtil(`${url}/Employers/jobs/view`, 'POST', { ...params });
      if (viewJobDetails?.jobTypeID) {
        const response = await requestUtil(
          `${url}/employers/get-dynamic-controls-for-job-creation`,
          'POST',
          { jobTypeId: viewJobDetails?.jobTypeID }
        );
        if (response?.tabsList) {
          dynamicFormData = response?.tabsList
        }
      } else {
        dynamicFormData = formdata
      }
      const formData = convertToEdit(viewJobDetails, masterData, requestData);
      if (viewJobDetails?.jobProfileForms?.length > 0 && dynamicFormData?.length) {
        newDynamicFormData = patchDynamicForm(dynamicFormData, viewJobDetails?.jobProfileForms);
        dispatch(setFormData(newDynamicFormData));
      }
      if (viewJobDetails?.jobSummeryJobsShifts && viewJobDetails?.jobSummeryJobsShifts?.shiftType === 3) {
        if (viewJobDetails?.jobSummeryJobsShifts?.recurrenceRule !== '') {
          str = convertToString(viewJobDetails?.jobSummeryJobsShifts?.recurrenceRule);
        }
      }
      dispatch(loadDataForEdit(formData));
      dispatch(updateViewJobDetails({
        data: {
          ...viewJobDetails, billingrate: viewJobDetails?.hourlyBillingRateToDisplay ? viewJobDetails?.hourlyBillingRateToDisplay : 0, shiftamount: viewJobDetails?.shiftAmount ? viewJobDetails?.shiftAmount : 0, dynamicForm: newDynamicFormData,
          rrurleStr: str, recursionFlag: viewJobDetails?.jobSummeryJobsShifts?.shiftType
        }
      }));
      dispatch(setJobDomainId(viewJobDetails?.jobTypeID))
      // dispatch(updateViewJobDetails(viewJobDetails))
      // console.log({viewJobDetails});
      // return viewJobDetails;
      // updateDepartments 
      if(requestData?.save){
        const departmentList = viewJobDetails?.departmentDetails
        // viewJobDetails?.departmentDetails?.length ? viewJobDetails?.departmentDetails?.map(deps => ({"candidateDepartmentId":deps?.id,"name":deps?.name})):[]
        dispatch(setDepartmentList(departmentList));
      }
    } catch (error) {
      console.log(error);
    } finally {
      // dispatch(setLoading(false))
      dispatch(setLoadingFlagDecrement());

    }
  };
};


export const updateRequest = ({ jobId, shiftDate, claimId, shiftStartTime, shiftEndTime, jobsShiftUniqueId, save, shiftType,viewJobTitle, occurrenceCorrectionType}) => {
  // console.log({jobId});
  return async (dispatch) => {
    dispatch(setJobId({ jobId, shiftDate, claimId, shiftStartTime, shiftEndTime, jobsShiftUniqueId, save, shiftType,viewJobTitle, occurrenceCorrectionType }))
  }
}


export const saveApproveJob = ({ url, params }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());
    // console.log(url, params);
    try {
      const response = await requestUtil(`${url}/Employers/approvejob`, 'POST', { ...params });
      Toasts.success('Candidate Rating Saved Successfully.');
      // dispatch(setLoading(false));
    } catch (error) {
      // dispatch(setLoading(false));
    }
    finally {
      dispatch(setLoadingFlagDecrement());
    }
  }
}

export function loadMasterData(baseUrl) {
  return async dispatch => {
    dispatch(setLoadingFlagIncrement());

    try {
      const shiftStartTime = await requestUtil(`${baseUrl}/Dropdown/get-shift-start-time`, 'GET');
      const shiftEndTime = await requestUtil(`${baseUrl}/Dropdown/get-shift-end-time`, 'GET');
      const shiftPreferedTime = await requestUtil(`${baseUrl}/Dropdown/get-shift-length-for-new-job`, 'GET');
      const shiftPreferedLength= await requestUtil(`${baseUrl}/Dropdown/get-shift-length-for-new-job`,'GET');
      dispatch(setMasterData({
        shiftStartTime: shiftStartTime?.shiftTimeList?.map((item) => { return { name: item.displayText, id: item.time }; }),
        shiftEndTime: shiftEndTime?.shiftTimeList?.map((item) => { return { name: item.displayText, id: item.time } }),
        shiftPreferedTime: shiftPreferedTime,
        shiftPreferedLength:shiftPreferedLength
      }))
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  }
}



// export function updateShift(field, value) {
//   return async (dispatch, getState) => {
//     const state = getState();
//     const { shift, masterData } = state.viewJobDetails;
//     dispatch(setLoading(true));
//     try {
//       const shiftLength = shift?.preferedShift?.id;
//       if (field === 'startTime' && shiftLength && shiftLength > 0) {
//         const endTime = moment(value?.name, 'hh:mm A').add(shiftLength, 'hours').subtract(0, 'minute').format('hh:mm A');
//         dispatch(updateShiftDetails({ field: 'endTime', data: masterData?.allShiftEndTime?.find((item) => item?.name === endTime) }));
//       }
//       if (field === 'preferedShift' && shift.startTime && shift.startTime !== 'Select') {
//         const endTime = moment(shift?.startTime?.name, 'hh:mm A').add(value.id, 'hours').subtract(0, 'minute').format('hh:mm A');
//         dispatch(updateShiftDetails({ field: 'endTime', data: masterData?.allShiftEndTime?.find((item) => item?.name === endTime) }));
//       }
//       const payload = { field: field, data: value }
//       dispatch(updateShiftDetails(payload))

//     } catch (error) {
//       dispatch(setFailureLogs(error.message))
//     }
//     dispatch(setLoading(false));
//   }
// }
export function updateShift(field, value) {
  return async (dispatch, getState) => {
    const state = getState();
    const { shift, masterData,recursionFlag=1 } = state.viewJobDetails
    try {
      const payload = { field: field, data: value };
      dispatch(updateShiftDetails(payload));
      if (field === "preferedShift" && shift.startTime) {
        const result = updateShiftTime({ currentValue: value?.id, updateField: "endTime", shiftStartTime: shift?.startTime?.id, masterData: masterData?.allShiftEndTime , shiftStartDate:shift?.date, shiftType:recursionFlag});
        const payload = {field:result?.field,data:result?.data}
        const singleShiftEndDate = {field:"endDate",data:result?.singleShiftEndDate}
        dispatch(updateShiftDetails(payload));
        dispatch(updateShiftDetails(singleShiftEndDate));
      }
      if (field === "startTime" && shift?.preferedShift) {
        const result = updateShiftTime({ currentValue: shift?.preferedShift?.id, updateField: "endTime", shiftStartTime: value?.id, masterData: masterData?.allShiftEndTime , shiftStartDate:shift?.date, shiftType:recursionFlag});
        console.log({result});
        const payload = {field:result?.field,data:result?.data}
        const singleShiftEndDate = {field:"endDate",data:result?.singleShiftEndDate}
        dispatch(updateShiftDetails(payload));
        dispatch(updateShiftDetails(singleShiftEndDate));
      }
      if (field === "startTime" && !shift?.preferedShift?.id && shift?.endTime?.id) {
        const payload = updateShiftTime({ currentValue: shift?.endTime?.id, updateField: "preferedShift", shiftStartTime: value.id, masterData: masterData?.allPreferedShifts, shiftStartDate:shift?.date, shiftType:recursionFlag });
        dispatch(updateShiftDetails(payload));
      }
      if (field === "endTime" && shift.startTime) {
        const result = updateShiftTime({ currentValue: value?.id, updateField: "preferedShift", shiftStartTime: shift.startTime.id, masterData: masterData?.allPreferedShifts, shiftStartDate:shift?.date, shiftType:recursionFlag });
        const payload = {field:result?.field,data:result?.data}
        const singleShiftEndDate = {field:"endDate",data:result?.singleShiftEndDate}
        dispatch(updateShiftDetails(payload));
        dispatch(updateShiftDetails(singleShiftEndDate));

      }
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    }
    dispatch(setLoading(false));
  };
}
export function updateJobInfoDetails(field, value) {
  return async dispatch => {
    dispatch(setLoading(true));
    try {
      const payload = { field: field, data: value }
      dispatch(updateJobInfo(payload))
    } catch (error) {
      dispatch(setFailureLogs(error.message))
    }
    dispatch(setLoading(false));
  }
}

export const convertToEdit = (data, masterDatas, requestData) => {
  const shiftStartTime = masterDatas?.allShiftStartTime?.find(startTime => startTime?.name === data?.shiftStartTime);
  const shiftStartTimeId = shiftStartTime?.id;
  const shiftLength = masterDatas?.allPreferedShifts?.find(shift => (shift.id === data?.shiftHours));
  const shiftLengthId = shiftLength?.id;
  return {
    shift: {
      startTime: shiftStartTime,
      endTime: masterDatas?.allShiftEndTime?.find(endTime => endTime?.name === data?.shiftEndTime),
      preferedShift:shiftLength,
      date: data?.jobDate?.split('T')[0],
      endDate: +data?.jobSummeryJobsShifts?.shiftType === shiftTypeObj.dailyEnocunter ? requestData?.shiftDate?.split('T')[0] : getSingleShiftEndDate(requestData?.shiftDate?.split('T')[0], shiftStartTimeId,shiftLengthId)
    },
    jobInfo: {
      jobTemplate: { id: data?.jobTemplateId, name: data?.jobTemplateName },
      jobCategory: { id: data?.employerJobCategoriesIdList[0]?.jobCategoryId, name: data?.employerJobCategoriesIdList[0]?.description },
      jobTitle: data?.jobTitle,
      jobDescription: data?.jobDescription,
      ratePerHour: data?.ratePerHour,
      incentive: data?.incentive
    },
  }
}

export const getDynamicFormData = ({ url, jobTypeId }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(
        `${url}/employers/get-dynamic-controls-for-job-creation`,
        'POST',
        { jobTypeId }
      );
      //const res = JSON.parse(JSON.stringify(response));
      //delete res.sections;
      // console.log(res);
      //console.log(response);
      if (response?.tabsList) {
        dispatch(setFormData(response?.tabsList));
      }
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    }
    finally {
      dispatch(setLoadingFlagDecrement());
    }
    // dispatch(setLoading(false));
  };
};


export const resetModifyOccurrence = () => {
  return async (dispatch) => {
    dispatch(setModifyOccurrence())
  }
}

export const modifyCheckinCheckoutTime = ({ url, params }) => {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement())
    try {
      const response = await requestUtil(`${url}/Employers/jobs/update-checkin-checkout-View`, 'POST', { ...params });
      Toasts.success(response?.message);
      return response
    } catch (error) {
      Toasts.error(error?.message);
    } finally {
      dispatch(setLoadingFlagDecrement())
    }
  }
}

export const getRatePerHour = ({ url, params }) => {
  return async (dispatch, getState) => {
    dispatch(setLoadingFlagIncrement());
    const state = getState();
    const { jobDetails } = state.viewJobDetails;
    try {
      const response = await requestUtil(
        `${url}/Employers/get-variable-payrate`,
        'POST',
        { ...params }
      );
      if (response?.getHourlyRates?.billingRate) {
        dispatch(updateViewJobDetails({
          data: { ...jobDetails, shiftamount: response?.getHourlyRates?.billingRate, billingrate: response?.getHourlyRates?.billingRateToDispaly }
        }))
      }
      if (response?.getHourlyRates?.billingRateToDispaly === "Variable") {
        dispatch(setOccurrenceViewVariableRate({
          name: 'occurrenceViewPayRate',
          value: response?.payRates,
        }))
      }
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const modifyShiftEndTime = ({ url, params }) => {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement())
    try {
      const response = await requestUtil(`${url}/Employers/jobs/UpdateShiftEndTime`, 'POST', { ...params });
      Toasts.success(response?.message);
      return response
    } catch (error) {
      Toasts.error(error?.message);
    } finally {
      dispatch(setLoadingFlagDecrement())
    }
  }
}


export const getOcccurrenceViewVariableRateDetails = ({ url, params }) => {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}/Employers/get-variable-payrate`, 'POST', { ...params });
      if (response?.payRates) {
        dispatch(setOccurrenceViewVariableRate({
          name: 'occurrenceViewPayRate',
          value: response?.payRates,
        }))
      }
    } catch (error) {
      Toasts.success(error?.message);
    } finally {
      dispatch(setLoadingFlagDecrement())
    }
  }
}


export function getEmailDetails({ url }) {
  return async (dispatch) => {
      dispatch(setLoadingFlagIncrement());
      try {
          const response = await requestUtil(`${url}`, "GET");
          return response;
      } catch (error) {
          return error.message;
      } finally {
          dispatch(setLoadingFlagDecrement());
      }
  };
}

export function sendEmail({ url, params }) {
  return async (dispatch) => {
      dispatch(setLoadingFlagIncrement());
      try {
          const response = await requestUtil(`${url}`, "POST", { ...params });
          Toasts.success("Email sent successfully!");
          return response;
      } catch (error) {
        Toasts.error("Email not sent!");
          return error.message;
      } finally {
          dispatch(setLoadingFlagDecrement());
      }
  };
}

export function getSMSDetails({ url,params }) {
  return async (dispatch) => {
      dispatch(setLoadingFlagIncrement());
      try {
          const response = await requestUtil(`${url}`, "POST",{...params});
          return response;
      } catch (error) {
          return error.message;
      } finally {
          dispatch(setLoadingFlagDecrement());
      }
  };
}

export function sendSMS({ url, params }) {
  return async (dispatch) => {
      dispatch(setLoadingFlagIncrement());
      try {
          const response = await requestUtil(`${url}`, "POST", { ...params });
          Toasts.success("Sms sent successfully!");
          return response;
      } catch (error) {
          return error.message;
      } finally {
          dispatch(setLoadingFlagDecrement());
      }
  };
}

export function sendAllEmailbtn(url) {
  return async (dispatch) => {
      dispatch(setLoadingFlagIncrement());
      try {
          const response = await fetch(url);
          return response;
      } catch (error) {
          return error.message;
      } finally {
          dispatch(setLoadingFlagDecrement());
      }
  };
}


export function sendAllSmsbtn(url) {
  return async (dispatch) => {
      dispatch(setLoadingFlagIncrement());
      try {
          const response = await fetch(url);
          return response;
      } catch (error) {
          return error.message;
      } finally {
          dispatch(setLoadingFlagDecrement());
      }
  };
}

export function getCallHistory(url, params) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${url}/Voice/get-recordings`,
        'POST', params
      );;
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}


export const fetchVariableDetails = (url, params) => {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const result = await requestUtil(url, "POST", { ...params });
      if (result) {
        return result
      }
    } catch (error) {
      return error
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  }
}

// Break Type List
export function getBreakTypeList(url, jobsclaimId) {
  return async (dispatch) => {
      dispatch(setLoadingFlagIncrement())
      try {
          const response = await requestUtil(`${url}/Dropdown/get-breaktype-by-location?jobsclaimId=${jobsclaimId}`, "GET")
          dispatch(setWorkBreakList(response))
      } catch(error){
          console.log(error.message);
      } finally {
          dispatch(setLoadingFlagDecrement())
      }
  };
}


// Update Break Info
export function updateBreakInfo(url, params) {
  return async (dispatch) => {
      dispatch(setLoadingFlagIncrement())
      try {
         const res = await requestUtil(`${url}/Employers/SaveJobsBreaks`, "POST", {...params});
         if (res?.result !== 0 ) {
          Toasts.success(res?.message);
         } else {
          Toasts.error(res?.message);
         }
         return res;
      } catch(error){
        Toasts.error(error.message);
          return error.message
      } finally {
          dispatch(setLoadingFlagDecrement())
      }
  };
}


export function completeCorrectionEncounter(url, params) {
  return async (dispatch) => {
      dispatch(setLoadingFlagIncrement())
      try {
         const res = await requestUtil(`${url}/Corrections/complete-encounter-corrections`, "POST", {...params});
         if (res?.result !== 0 ) {
          Toasts.success(res?.message);
         } else {
          Toasts.error(res?.message);
         }
         return res;
      } catch(error){
        Toasts.error(error.message);
          return error.message
      } finally {
          dispatch(setLoadingFlagDecrement())
      }
  };
}